function initFaqDS() {
  const selectors = {
    accordionHeader: ".faqDS__accordionItemHeader",
    accordionItem: ".faqDS__accordionItem",
    accordionContent: ".faqDS__accordionItemContent",

    accordionDescriptionClass: 'faqDS__accordionItemContentDescription',
    accordionItemActiveClass: "faqDS__accordionItem--active"
  }

  const accordionArray = document.querySelectorAll(selectors.accordionItem);

  function toggleAccordion(event) {
    const item = event.currentTarget;
    const itemContent = item.querySelector(selectors.accordionContent);
    const trigger = item.querySelector(selectors.accordionHeader);

    if (item.classList.contains(selectors.accordionItemActiveClass)) {
      item.classList.remove(selectors.accordionItemActiveClass);
      itemContent.style.height = '0';
      itemContent.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    } else {
      item.classList.add(selectors.accordionItemActiveClass);
      itemContent.hidden = false;
      itemContent.style.height = `${itemContent.scrollHeight}px`;
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }
  };

  accordionArray.forEach(accordion => {
    // Guard: multiple faq-ds sections on one page each load this script,
    // so init runs more than once. Double-binding makes every click toggle
    // an even number of times (= appears dead).
    if (accordion.dataset.faqDsBound) return;
    accordion.dataset.faqDsBound = '1';
    accordion.addEventListener('click', (event) => {
      if (!event.target.classList.contains(selectors.accordionDescriptionClass)) {
        toggleAccordion(event);
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initFaqDS);
document.addEventListener('cart:reloaded', initFaqDS);
